import React from 'react'

import PropTypes from 'prop-types'

import './frametitle.css'

const Frametitle = (props) => {
  return (
    <div className={`frametitle-thq-chapters-elm ${props.rootClassName} `}>
      <div className="frametitle-thq-active-elm">
        <div className="frametitle-thq-content-elm">
          <img alt="image" src={props.image} className="frametitle-image" />
          <div className="frametitle-thq-text-elm">
            <span className="frametitle-text">{props.name}</span>
          </div>
        </div>
        <div className="frametitle-thq-width-elm"></div>
        <div className="frametitle-thq-height-elm"></div>
      </div>
    </div>
  )
}

Frametitle.defaultProps = {
  rootClassName: '',
  name: 'instagram.com/romania',
  image: '/frames/trophy_blue.svg',
}

Frametitle.propTypes = {
  rootClassName: PropTypes.string,
  name: PropTypes.string,
  image: PropTypes.string,
}

export default Frametitle
